import Vue from 'vue'

class AdspaceHelper {
  static async load () {
    let endpoint = `${process.env.VUE_APP_API_DOMAIN}/adspaces`
    return Vue.prototype.$http.get(endpoint)
      .then(res => res.data)
      .catch(err => console.log(err))
  }
  static getAdspace (id) {
    let value = ''
    JSON.parse(localStorage.getItem('adspaces')).filter(item => {
      if (item._id === id) value = item
    })

    return value
  }
}

export default AdspaceHelper
